(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muse-product-carousel')) {
    customElements.define('muse-product-carousel', class extends HTMLElement {
      async connectedCallback() {
        const track = this.querySelector('[data-carousel-track]');
        if (!track) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track.scrollBy({ left: -this.step(track), behavior: 'smooth' }), options);
        this.querySelector('[data-carousel-next]')?.addEventListener('click', () => track.scrollBy({ left: this.step(track), behavior: 'smooth' }), options);
        const bar = this.querySelector('[data-carousel-progress]');
        const progress = () => {
          if (!bar) return;
          const max = track.scrollWidth - track.clientWidth;
          const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          bar.style.width = `${Math.max(12, ratio * 100)}%`;
          bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (100 / Math.max(ratio, .12) - 100) : 0}%)`;
          this.classList.toggle('is-start', track.scrollLeft < 4);
          this.classList.toggle('is-end', track.scrollLeft > max - 4);
        };
        track.addEventListener('scroll', () => requestAnimationFrame(progress), { ...options, passive: true });
        window.addEventListener('resize', progress, options);
        window.addEventListener('load', progress, options);
        progress();
        const nativeTouch = this.dataset.source === 'related' || this.dataset.source === 'recent';
        if (!nativeTouch && matchMedia('(max-width: 749px)').matches) this.setupMobileSwipe(track, options);
        if (this.dataset.source !== 'collection' && !this.loaded) {
          this.loaded = true;
          try {
            let ids = [];
            let url;
            if (this.dataset.source === 'recent') {
              ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]').map(String).filter(id => /^\d+$/.test(id) && id !== this.dataset.currentProduct).slice(0, 10);
              if (!ids.length) return;
              url = new URL(this.dataset.searchUrl, location.origin);
              url.searchParams.set('q', ids.map(id => 'id:' + id).join(' OR '));
              url.searchParams.set('type', 'product');
            } else {
              url = new URL(this.dataset.recommendationsUrl, location.origin);
              url.searchParams.set('product_id', this.dataset.currentProduct);
              url.searchParams.set('intent', 'related');
              url.searchParams.set('limit', '10');
            }
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url);
            if (!response.ok) return;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const incoming = doc.querySelector('[data-carousel-track]');
            if (!incoming?.querySelector('.product-card')) return;
            if (ids.length) {
              const items = [...incoming.querySelectorAll('[data-muse-item]')];
              ids.forEach(id => {
                const item = items.find(item => item.dataset.museItem === id);
                if (item) incoming.append(item);
              });
            }
            if (!this.isConnected) return;
            this.querySelector('[data-carousel-track]').replaceChildren(...incoming.childNodes);
            this.hidden = false;
            requestAnimationFrame(progress);
            setTimeout(progress, 400);
          } catch { return; }
        }
        if (nativeTouch || matchMedia('(max-width: 749px)').matches) {
          this.querySelectorAll('.card-gallery slideshow-component').forEach(slideshow => slideshow.setAttribute('disabled', 'true'));
        }
      }
      setupMobileSwipe(track, options) {
        let gesture;
        track.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) { gesture = null; return; }
          const touch = event.touches[0];
          gesture = { x: touch.clientX, y: touch.clientY, lastX: touch.clientX, scrollLeft: track.scrollLeft, axis: null };
        }, { ...options, passive: true });
        track.addEventListener('touchmove', event => {
          if (!gesture || event.touches.length !== 1) return;
          const touch = event.touches[0];
          const dx = touch.clientX - gesture.x;
          const dy = touch.clientY - gesture.y;
          if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 8) gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (gesture.axis !== 'x') return;
          event.preventDefault();
          track.style.scrollSnapType = 'none';
          track.scrollLeft = gesture.scrollLeft - dx;
          gesture.lastX = touch.clientX;
        }, { ...options, passive: false });
        const finish = cancelled => {
          if (!gesture) return;
          if (gesture.axis === 'x') {
            const step = this.step(track);
            const distance = gesture.lastX - gesture.x;
            const startIndex = Math.round(gesture.scrollLeft / step);
            let targetIndex = Math.round(track.scrollLeft / step);
            if (!cancelled && Math.abs(distance) > 36 && targetIndex === startIndex) targetIndex += distance < 0 ? 1 : -1;
            track.style.scrollSnapType = '';
            track.scrollTo({ left: Math.max(0, targetIndex * step), behavior: 'smooth' });
          }
          gesture = null;
        };
        track.addEventListener('touchend', () => finish(false), options);
        track.addEventListener('touchcancel', () => finish(true), options);
      }
      step(track) {
        const card = track.querySelector('.product-card');
        return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth * .8;
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-header"] && !Shopify.designMode) return;
  try {
    
  // Focus rings only for keyboard users (menu opens with focus on its close button)
  document.addEventListener('keydown', (e) => { if (e.key === 'Tab') document.documentElement.classList.add('mm-kbd'); });
  document.addEventListener('pointerdown', () => document.documentElement.classList.remove('mm-kbd'));
  class MuseHeader extends HTMLElement {
    connectedCallback() {
      this.handleCartCountUpdate = event => {
        event.promise?.then(({ cart, detail }) => {
          if (detail?.didError) return;
          const count = cart?.totalQuantity ?? detail?.itemCount;
          if (typeof count !== 'number') return;
          this.querySelectorAll('[data-cart-count]').forEach(badge => {
            badge.textContent = String(count);
            badge.hidden = count === 0;
          });
        }).catch(() => {});
      };
      document.addEventListener('shopify:cart:lines-update', this.handleCartCountUpdate);
      this.querySelectorAll('a[href="/cart"]').forEach(link => link.addEventListener('click', async event => {
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        if (this.dialog?.open) this.closeMenu();
        this.toggleInfoMenu(false);
        this.querySelectorAll('.muse-header__nav-details[open]').forEach((details) => details.removeAttribute('open'));
        await customElements.whenDefined('theme-drawer');
        drawer.open();
      }));
      this.searchInputs = this.querySelectorAll('input[type="search"]');
      this.searchInputs.forEach((input) => input.addEventListener('focus', () => this.closeCartDrawer()));
      this.searchTerms = (this.dataset.searchTerms || '').split('|').map((term) => term.trim()).filter(Boolean);
      if (this.searchTerms.length) {
        const prefix = this.dataset.searchPrefix || 'Αναζήτησε...';
        this.searchTermIndex = 0;
        this.searchCharacterIndex = 0;
        this.searchDeleting = false;
        this.updateSearchPlaceholders = () => {
          const term = this.searchTerms[this.searchTermIndex].slice(0, this.searchCharacterIndex);
          const placeholder = term ? `${prefix} ${term}` : prefix;
          this.searchInputs.forEach((input) => { input.placeholder = placeholder; });
        };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.searchCharacterIndex = this.searchTerms[0].length;
        } else {
          this.typeSearchPlaceholder = () => {
            if (document.hidden) {
              this.searchPlaceholderTimer = window.setTimeout(this.typeSearchPlaceholder, 1000);
              return;
            }
            const termLength = this.searchTerms[this.searchTermIndex].length;
            let delay;
            if (this.searchDeleting) {
              if (this.searchCharacterIndex > 0) {
                this.searchCharacterIndex -= 1;
                delay = 55;
              } else {
                this.searchDeleting = false;
                this.searchTermIndex = (this.searchTermIndex + 1) % this.searchTerms.length;
                delay = 250;
              }
            } else if (this.searchCharacterIndex < termLength) {
              this.searchCharacterIndex += 1;
              delay = 105;
            } else {
              this.searchDeleting = true;
              delay = 1650;
            }
            this.updateSearchPlaceholders();
            this.searchPlaceholderTimer = window.setTimeout(this.typeSearchPlaceholder, delay);
          };
          this.searchPlaceholderTimer = window.setTimeout(this.typeSearchPlaceholder, 500);
        }
        this.updateSearchPlaceholders();
      }
      this.announcement = this.querySelector('.muse-header__announcement');
      if (this.announcement || this.dataset.overlay === 'true') {
        this.announcementHeight = this.announcement?.offsetHeight || 30;
        this.announcementMedia = window.matchMedia('(min-width: 990px)');
        this.updateAnnouncementVisibility = () => {
          const scrollTop = this.announcementScrollTarget === window ? window.scrollY : this.announcementScrollTarget.scrollTop;
          if (this.dataset.overlay === 'true') {
            const isScrolled = scrollTop > 4;
            this.classList.toggle('is-scrolled', isScrolled);
            if (this.announcement) this.announcement.inert = isScrolled || !this.announcementMedia.matches;
            return;
          }
          if (scrollTop > Math.max(64, this.announcementHeight + 24)) {
            this.classList.add('is-announcement-hidden');
            this.announcement.inert = true;
          } else if (scrollTop <= 4) {
            this.classList.remove('is-announcement-hidden');
            this.announcement.inert = false;
          }
        };
        this.bindAnnouncementScroll = () => {
          this.announcementScrollTarget?.removeEventListener('scroll', this.updateAnnouncementVisibility);
          this.announcementScrollTarget = this.announcementMedia.matches ? document.querySelector('.page-wrapper') || window : window;
          this.announcementScrollTarget.addEventListener('scroll', this.updateAnnouncementVisibility, { passive: true });
          if (this.announcement && !this.classList.contains('is-scrolled') && !this.classList.contains('is-announcement-hidden')) {
            const height = this.announcement.offsetHeight;
            if (height) this.announcementHeight = height;
          }
          this.updateAnnouncementVisibility();
        };
        this.announcementMedia.addEventListener('change', this.bindAnnouncementScroll);
        this.bindAnnouncementScroll();
      }
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.infoButton = this.querySelector('[data-info-toggle]');
      this.infoPanel = this.querySelector('[data-info-panel]');
      this.infoBackdrop = this.querySelector('[data-info-backdrop]');
      this.infoBackdrop?.addEventListener('click', () => { this.toggleInfoMenu(false); this.infoButton.focus(); });
      this.infoButton?.addEventListener('click', () => this.toggleInfoMenu(this.infoPanel.hidden || this.infoPanel.classList.contains('is-closing')));
      this.infoKeydown = (event) => {
        if (!this.infoPanel || this.infoPanel.hidden) return;
        if (event.key === 'Escape') { this.toggleInfoMenu(false); this.infoButton.focus(); }
      };
      document.addEventListener('keydown', this.infoKeydown);
      this.megaOutside = (event) => {
        if (event.target.closest?.('.muse-header__nav-details')) return;
        this.querySelectorAll('.muse-header__nav-details[open]').forEach((details) => this.closeMegaMenu(details));
      };
      this.megaEscape = (event) => {
        if (event.key !== 'Escape') return;
        this.querySelectorAll('.muse-header__nav-details[open]').forEach((details) => {
          this.closeMegaMenu(details);
          details.querySelector('summary')?.focus();
        });
      };
      document.addEventListener('pointerdown', this.megaOutside);
      document.addEventListener('keydown', this.megaEscape);
      this.infoResize = () => {
        document.documentElement.style.setProperty('--muse-header-height', `${this.getBoundingClientRect().height}px`);
        if (window.innerWidth < 990) this.toggleInfoMenu(false);
        else this.style.setProperty('--muse-info-top', `${this.querySelector('[data-header]').getBoundingClientRect().bottom}px`);
      };
      this.infoObserver = new ResizeObserver(this.infoResize);
      this.infoObserver.observe(this);
      window.addEventListener('resize', this.infoResize);
      this.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.toggleInfoMenu(false); }); });
      this.openButton = this.querySelector('[data-menu-open]');
      this.closeButton = this.querySelector('[data-menu-close]');
      this.openButton?.addEventListener('click', () => this.openMenu());
      this.closeButton?.addEventListener('click', () => this.closeMenu());
      this.menuBack = this.querySelector('[data-menu-back]');
      this.menuBack?.addEventListener('click', () => this.closeSubmenu(this.activeSubmenu));
      const mobileInfo = this.querySelector('[data-mobile-info-links]');
      // Mobile «Πληροφορίες»: same links as the desktop info panel, minus Instagram and the legal pages
      const skipOnMobile = /instagram\.com|\/pages\/oroi-xrisis|\/pages\/politiki-aporritou/;
      this.querySelectorAll('.muse-info__primary a, .muse-info__support a').forEach(link => {
        if (!skipOnMobile.test(link.getAttribute('href') || '')) mobileInfo?.append(link.cloneNode(true));
      });
      this.mobileSearchInput = this.querySelector('.muse-header__search--mobile input');
      this.handleMobileSearchFocus = () => this.preventIosFocusZoom();
      this.mobileSearchInput?.addEventListener('focus', this.handleMobileSearchFocus);
      this.drawerSearchInput = this.querySelector('.muse-menu__search input');
      this.drawerSearchInput?.addEventListener('focus', this.handleMobileSearchFocus);
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeMenu();
      });
      this.dialog?.addEventListener('close', () => {
        this.openButton?.setAttribute('aria-expanded', 'false');
        this.lockPageScroll(false);
      });
      this.querySelectorAll('[data-submenu-open]').forEach((button) => {
        button.addEventListener('click', () => this.openSubmenu(button));
      });
      this.querySelectorAll('[data-submenu-back]').forEach((button) => {
        button.addEventListener('click', () => this.closeSubmenu(button.closest('[data-submenu-panel]')));
      });
      this.menuExitAnimations = new Map();
      this.querySelector('[data-mega-backdrop]')?.addEventListener('click', () => {
        this.querySelectorAll('.muse-header__nav-details[open]').forEach((details) => this.closeMegaMenu(details));
      });
      this.querySelectorAll('.muse-header__nav-details').forEach((details) => {
        details.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.cancelMenuExit(details.querySelector('.muse-header__mega'));
          this.cancelMenuExit(this.querySelector('[data-mega-backdrop]'));
          this.toggleInfoMenu(false);
          if (!details.open) details.dataset.openedAt = String(Date.now());
          details.setAttribute('open', '');
        });
        details.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          // Keep it open only while navigating with the keyboard inside it.
          if (!details.querySelector(':focus-visible')) this.closeMegaMenu(details);
        });
        details.querySelector('summary')?.addEventListener('click', (event) => {
          if (!details.open) {
            details.dataset.openedAt = String(Date.now());
            return;
          }
          event.preventDefault();
          // A click right after the hover opened it is the same intent: keep it open.
          const justOpened = Date.now() - Number(details.dataset.openedAt || 0) < 400;
          if (event.detail === 0 || !justOpened) this.closeMegaMenu(details);
        });
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.closeCartDrawer();
          this.infoResize();
          this.querySelectorAll('.muse-header__nav-details[open]').forEach((item) => {
            if (item !== details) item.removeAttribute('open');
          });
        });
      });

    }

    disconnectedCallback() {
      document.removeEventListener('shopify:cart:lines-update', this.handleCartCountUpdate);
      window.clearInterval(this.promoTimer);
      this.toggleInfoMenu(false);
      this.menuExitAnimations?.forEach((animation) => animation.cancel());
      this.menuExitAnimations?.clear();
      document.removeEventListener('keydown', this.infoKeydown);
      document.removeEventListener('pointerdown', this.megaOutside);
      document.removeEventListener('keydown', this.megaEscape);
      window.removeEventListener('resize', this.infoResize);
      this.infoObserver?.disconnect();
      window.clearTimeout(this.searchPlaceholderTimer);
      this.announcementScrollTarget?.removeEventListener('scroll', this.updateAnnouncementVisibility);
      this.announcementMedia?.removeEventListener('change', this.bindAnnouncementScroll);
      this.mobileSearchInput?.removeEventListener('focus', this.handleMobileSearchFocus);
      this.drawerSearchInput?.removeEventListener('focus', this.handleMobileSearchFocus);
      window.clearTimeout(this.viewportRestoreTimer);
      this.restoreViewport();
    }

    cancelMenuExit(element) {
      this.menuExitAnimations?.get(element)?.cancel();
      this.menuExitAnimations?.delete(element);
      element?.classList.remove('is-closing');
    }

    animateMenuExit(element, complete, backdrop = false) {
      if (!element || element.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { complete(); return; }
      element.classList.add('is-closing');
      const frames = backdrop ? [{ opacity: 1 }, { opacity: 0 }] : [{ opacity: 1, clipPath: 'inset(0 0 0 0)' }, { opacity: .4, clipPath: 'inset(0 0 100% 0)' }];
      const animation = element.animate(frames, { duration: backdrop ? 380 : 340, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' });
      this.menuExitAnimations.set(element, animation);
      animation.onfinish = () => {
        complete();
        this.cancelMenuExit(element);
      };
    }

    closeMegaMenu(details) {
      this.animateMenuExit(this.querySelector('[data-mega-backdrop]'), () => {}, true);
      this.animateMenuExit(details.querySelector('.muse-header__mega'), () => details.removeAttribute('open'));
    }

    toggleInfoMenu(open) {
      if (open) {
        this.closeCartDrawer();
        this.cancelMenuExit(this.infoPanel);
        this.cancelMenuExit(this.infoBackdrop);
      } else if (this.infoPanel && !this.infoPanel.hidden && this.isConnected) {
        this.animateMenuExit(this.infoBackdrop, () => { this.infoBackdrop.hidden = true; }, true);
        this.animateMenuExit(this.infoPanel, () => this.finishInfoMenuClose());
        return;
      }
      if (!this.infoPanel || this.infoPanel.hidden === !open) return;
      this.infoPanel.hidden = !open;
      if (this.infoBackdrop) this.infoBackdrop.hidden = !open;
      this.classList.toggle('is-info-open', open);
      this.infoButton.setAttribute('aria-expanded', String(open));
      if (open) {
        this.querySelectorAll('.muse-header__nav-details[open]').forEach((details) => details.removeAttribute('open'));
        this.infoResize();
        this.infoScrollTarget = document.querySelector('.page-wrapper') || document.documentElement;
        this.infoPreviousOverflow = this.infoPreviousOverflow ?? this.infoScrollTarget.style.overflow;
        this.infoScrollTarget.style.overflow = 'hidden';
        this.infoPanel.querySelector('a')?.focus({ preventScroll: true });
      } else if (this.infoScrollTarget) {
        this.infoScrollTarget.style.overflow = this.infoPreviousOverflow;
        this.infoScrollTarget = null;
        this.infoPreviousOverflow = null;
      }
    }

    finishInfoMenuClose() {
      this.infoPanel.hidden = true;
      this.infoBackdrop.hidden = true;
      this.classList.remove('is-info-open');
      this.infoButton.setAttribute('aria-expanded', 'false');
      if (this.infoScrollTarget) this.infoScrollTarget.style.overflow = this.infoPreviousOverflow;
      this.infoScrollTarget = null;
      this.infoPreviousOverflow = null;
    }

    preventIosFocusZoom() {
      const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const viewport = document.querySelector('meta[name="viewport"]');
      if (!isIos || !viewport) return;
      this.viewportMeta = viewport;
      this.viewportContent = viewport.getAttribute('content') || 'width=device-width,initial-scale=1';
      const content = this.viewportContent
        .split(',')
        .map((value) => value.trim())
        .filter((value) => !value.startsWith('maximum-scale') && !value.startsWith('user-scalable'))
        .join(',');
      viewport.setAttribute('content', `${content},maximum-scale=1`);
      window.clearTimeout(this.viewportRestoreTimer);
      this.viewportRestoreTimer = window.setTimeout(() => this.restoreViewport(), 450);
    }

    restoreViewport() {
      if (!this.viewportMeta || !this.viewportContent) return;
      this.viewportMeta.setAttribute('content', this.viewportContent);
      this.viewportMeta = null;
      this.viewportContent = null;
    }

    closeCartDrawer() {
      const drawer = document.getElementById('cart-drawer');
      if (drawer?.isOpen) drawer.close();
    }

    openMenu() {
      if (!this.dialog) return;
      this.closeCartDrawer();
      this.dialog.showModal();
      this.lockPageScroll(true);
      this.openButton?.setAttribute('aria-expanded', 'true');
      this.closeButton?.focus();
      window.clearInterval(this.promoTimer);
      const promos = this.querySelector('[data-menu-promos]');
      if (promos && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.promoTimer = window.setInterval(() => {
          if (!this.dialog.open || this.activeSubmenu || document.hidden || promos.matches(':focus-within')) return;
          const step = promos.firstElementChild.getBoundingClientRect().width;
          const end = promos.scrollWidth - promos.clientWidth;
          const next = promos.scrollLeft >= end - 2 ? 0 : Math.min(end, promos.scrollLeft + step);
          promos.scrollTo({ left: next, behavior: 'smooth' });
        }, 3000);
      }
    }

    closeMenu() {
      window.clearInterval(this.promoTimer);
      this.resetSubmenus();
      this.dialog?.close();
      this.openButton?.focus();
    }

    /* MYMUSE: iOS keeps scrolling the page behind a modal dialog — lock it while the menu is open. */
    lockPageScroll(lock) {
      document.documentElement.classList.toggle('mm-menu-open', lock);
    }

    openSubmenu(button) {
      const panel = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
      if (!panel) return;
      this.activeSubmenu = panel;
      panel.getAnimations().forEach(animation => animation.cancel());
      panel.hidden = false;
      this.dialog.classList.add('has-submenu');
      this.querySelector('[data-menu-screen-title]').textContent = button.textContent.trim();
      this.querySelector('.muse-menu__search').inert = true;
      this.querySelector('[data-menu-promos]').inert = true;
      this.querySelector('.muse-menu__root').inert = true;
      this.menuBack.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) panel.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], { duration: 240, easing: 'cubic-bezier(.23,1,.32,1)' });
      this.menuBack.focus();
    }

    closeSubmenu(panel) {
      if (!panel) return;
      const opener = this.querySelector(`[aria-controls="${panel.id}"]`);
      panel.getAnimations().forEach(animation => animation.cancel());
      const finish = () => { panel.hidden = true; };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else panel.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], { duration: 200, easing: 'cubic-bezier(.23,1,.32,1)' }).onfinish = finish;
      this.activeSubmenu = null;
      this.dialog.classList.remove('has-submenu');
      this.querySelector('.muse-menu__search').inert = false;
      this.querySelector('[data-menu-promos]').inert = false;
      this.querySelector('.muse-menu__root').inert = false;
      this.menuBack.hidden = true;
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    }

    resetSubmenus() {
      this.activeSubmenu = null;
      this.dialog?.classList.remove('has-submenu');
      this.querySelector('.muse-menu__search').inert = false;
      this.querySelector('[data-menu-promos]').inert = false;
      this.querySelector('.muse-menu__root').inert = false;
      if (this.menuBack) this.menuBack.hidden = true;
      this.querySelectorAll('[data-submenu-panel]').forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
      this.querySelectorAll('[data-submenu-panel]').forEach((panel) => { panel.hidden = true; });
      this.querySelectorAll('[data-submenu-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
  }

  if (!customElements.get('muse-header')) customElements.define('muse-header', MuseHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muse-hero-slideshow')) {
    customElements.define('muse-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.muse-home__slide')];
        if (this.slides.length < 2) return;
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.mobileSlideshow = matchMedia('(max-width: 749px)').matches;
        this.firstImage = this.slides[0].querySelector('img');
        this.firstImageLoaded = !this.mobileSlideshow || !this.firstImage || (this.firstImage.complete && this.firstImage.naturalWidth > 0);
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        if (this.mobileSlideshow && !this.firstImageLoaded) {
          this.firstImage.addEventListener('load', () => { this.firstImageLoaded = true; this.schedule(); }, options);
        }
        this.addEventListener('dragstart', event => event.preventDefault(), options);
        this.addEventListener('mousedown', event => {
          this.suppressClick = false;
          if (event.button !== 0 || event.target.closest('button') || this.gesture?.touch) return;
          event.preventDefault();
          this.gesture = { id: 'mouse', x: event.clientX, y: event.clientY, horizontal: false, vertical: false };
          this.schedule();
        }, options);
        window.addEventListener('mousemove', event => {
          this.moveGesture({ pointerId: 'mouse', clientX: event.clientX, clientY: event.clientY, preventDefault: () => event.preventDefault() });
        }, options);
        window.addEventListener('mouseup', event => this.endGesture({ pointerId: 'mouse', clientX: event.clientX, clientY: event.clientY }), options);
        window.addEventListener('blur', () => { this.gesture = null; this.classList.remove('is-dragging'); this.schedule(); }, options);
        this.addEventListener('touchstart', event => {
          this.suppressClick = false;
          if (event.touches.length !== 1 || event.target.closest('button')) { this.gesture = null; return; }
          const touch = event.touches[0];
          this.gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, horizontal: false, vertical: false, touch: true };
          this.schedule();
        }, { ...options, passive: true });
        this.addEventListener('touchmove', event => {
          if (event.touches.length !== 1) { this.gesture = null; this.classList.remove('is-dragging'); this.schedule(); return; }
          const touch = event.touches[0];
          this.moveGesture({ pointerId: touch.identifier, clientX: touch.clientX, clientY: touch.clientY, preventDefault: () => { if (event.cancelable) event.preventDefault(); } });
        }, { ...options, passive: false });
        for (const type of ['touchend', 'touchcancel']) this.addEventListener(type, event => {
          const touch = [...event.changedTouches].find(touch => touch.identifier === this.gesture?.id);
          if (touch) this.endGesture({ pointerId: touch.identifier, clientX: touch.clientX, clientY: touch.clientY }, type === 'touchcancel');
        }, options);
        this.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
        }, { ...options, capture: true });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.schedule(); }, options));
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => { const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (index >= 0) { this.paused = true; this.show(index); this.schedule(); } }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.dataset.ready = 'true';
        this.schedule();
      }
      show(index) {
        this.index = index;
        this.slides.forEach((slide, i) => { const active = i === index; slide.classList.toggle('is-active', active); slide.inert = !active; slide.setAttribute('aria-hidden', String(!active)); });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
      moveGesture(event) {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId || gesture.vertical) return;
        const dx = Math.abs(event.clientX - gesture.x);
        const dy = Math.abs(event.clientY - gesture.y);
        if (!gesture.horizontal && Math.max(dx, dy) >= 6) {
          gesture.horizontal = dx > dy;
          gesture.vertical = !gesture.horizontal;
        }
        if (gesture.horizontal) { this.classList.add('is-dragging'); event.preventDefault(); }
      }
      endGesture(event, cancelled = false) {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        this.gesture = null;
        this.classList.remove('is-dragging');
        this.suppressClick = gesture.horizontal && !cancelled;
        if (!cancelled && !gesture.vertical && Math.abs(dx) >= 35 && (gesture.horizontal || Math.abs(dx) > Math.abs(dy) * 1.2)) {
          this.show((this.index + (dx < 0 ? 1 : -1) + this.slides.length) % this.slides.length);
          this.suppressClick = true;
        }
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.gesture || this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
        if (this.mobileSlideshow && this.index === 0 && !this.firstImageLoaded) return;
        const delay = this.mobileSlideshow && this.index === 0 ? 5000 : Number(this.dataset.interval);
        this.timer = setTimeout(() => { this.show((this.index + 1) % this.slides.length); this.schedule(); }, delay);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
